import { render, staticRenderFns } from "./watch-card-ctrl.vue?vue&type=template&id=32d60d76"
import script from "./watch-card-ctrl.vue?vue&type=script&lang=js"
export * from "./watch-card-ctrl.vue?vue&type=script&lang=js"
import style0 from "./watch-card-ctrl.vue?vue&type=style&index=0&id=32d60d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports